import { ReactNode } from 'react'

import { FinanceBalanceTicketType, FinanceInvoice } from '@/api/models/finance'

export type BalanceInvoiceProp = FinanceBalanceTicketType | FinanceInvoice

export type BalanceInvoiceMap = {
  id?: string
  name: string
  debtSum: number
  totalSum?: number
  invoicePeriod?: string
  customerName?: string | null
  premiseName?: string | null
  merchId?: string
}

export enum PayMethods {
  Acquiring = 'acquiring',
  Qr = 'qr'
}

export type PayMethodsOption = {
  key: PayMethods
  name: string
  description: string
  icon: ReactNode
}

export type ReceiptMethods = 'phone' | 'email'

export type ReceiptMethodsOption = {
  key: ReceiptMethods
  name: string
}
